import { PUT_CODIGODISPOSITIVO, PUT_EMAIL, PUT_PASSWORD } from '../actions/types';

const initialState = {
    email: "",//'ATACZA@ITERPCONSULTING.COM',
    password: null,
    codigoDispositivo: null
}

const AuthReducer = (state = initialState, action) => {
    switch (action.type) {
        case PUT_EMAIL:
            return {
                ...state,
                email: action.data.email
            };
        case PUT_PASSWORD:
            return {
                ...state,
                password: action.data.password
            };
        case PUT_CODIGODISPOSITIVO:
            return {
                ...state,
                codigoDispositivo: action.data.codigoDispositivo
            };
        default:
            return state;
    }
}

export default AuthReducer;